export function getMonthNum(startDate, endDate) {
  var val = 0
  if (startDate === undefined || endDate === undefined) {
    val = 0
  } else {
    var date1 = startDate.split('-')
    var date2 = endDate.split('-')
    date1[0] = parseInt(date1[0])
    date1[1] = parseInt(date1[1])
    date1[2] = parseInt(date1[2])
    date2[0] = parseInt(date2[0])
    date2[1] = parseInt(date2[1])
    date2[2] = parseInt(date2[2])
    if (date1[1] < date2[1]) {
      val = Math.abs(date1[0] - date2[0]) * 12 + Math.abs(date1[1] - date2[1])
    } else {
      val = Math.abs(date1[0] - date2[0]) * 12 - Math.abs(date1[1] - date2[1])
    }
    if (date1[2] > date2[2] && val > 0) {
      val--
    }
  }
  return val
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function objKeySort(obj) {
  var newkey = Object.keys(obj).sort()
  var newObj = {}
  for (var i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = obj[newkey[i]]
  }
  return newObj
}

export function objArrayKeySort(objArray) {
  var result = []
  for (let i = 0; i < objArray.length; i++) {
    result.push(objKeySort(objArray[i]))
  }
  return result
}



// WEBPACK FOOTER //
// ./src/utils/index.js